export default "__VITE_ASSET__BI5aDRQg__"